import { css } from '@emotion/react';

export const energyRateLinesStyles = {
    container: css({
        width: '100%',
        marginTop: 12,
        marginBottom: 12,
    }),
    title: css({
        fontSize: 12,
        fontWeight: 500,
        textTransform: 'uppercase',
        color: '#303030',
        marginBottom: 6,
    }),
    list: css({
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
    }),
    row: css({
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        columnGap: 12,
        alignItems: 'center',
    }),
    left: css({
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        minWidth: 0,
    }),
    dot: css({
        width: 7,
        height: 7,
        borderRadius: '50%',
        backgroundColor: '#D9D9D9',
        flex: '0 0 7px',
    }),
    dotActive: css({
        backgroundColor: '#3CBC00',
    }),
    dotCompleted: css({
        backgroundColor: '#004FC6',
    }),
    label: css({
        fontSize: 12,
        fontWeight: 400,
        color: '#000000',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }),
    value: css({
        fontSize: 12,
        fontWeight: 400,
        color: '#000000',
        whiteSpace: 'nowrap',
        textAlign: 'right',
    }),
    status: css({
        fontSize: 12,
        fontWeight: 600,
        color: '#9B9B9B',
        marginLeft: 8,
        whiteSpace: 'nowrap',
    }),
    statusActive: css({
        color: '#3CBC00',
    }),
    statusCompleted: css({
        color: '#004FC6',
    }),
};

